export class SlideAction {
  _id?: string;
  icon: string = '';
  label: string = '';
  type: 'change-media' | 'youtube' | 'url' | 'anchor' = 'url';
  image: string = '';
  video: string = '';
  backgroundImage: string = '';
  backgroundVideo: string = '';
  colorPrimary: string = '';
  colorSecondary: string = '';
  url: string = '';
  youtubeCode: string = '';
  youtubePoster: string = '';
  anchor: string = '';
  anchorSection: number = null;
  position: number = 0;
  style: 'icon' | 'color' | 'button' | 'button-border-primary' | 'button-border-secondary' | 'button-video' = 'icon';
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/common/models/slide-action.model.ts